import { render, staticRenderFns } from "./importmenu.vue?vue&type=template&id=23792437"
import script from "./importmenu.vue?vue&type=script&lang=js"
export * from "./importmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports